import { Component, CUSTOM_ELEMENTS_SCHEMA, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { tap } from 'rxjs';
import { EscalationParentType } from '@shs-digi-care-monorepo/interfaces';
import { EscalationService } from '../../services/escalation.service';
import { EscalationView } from '../../services/escalation.model';
import { PageLayoutComponent } from '../page-layout/page-layout.component';
import { TableComponent } from '../../ui/table/table.component';
import { TableHeadComponent } from '../../ui/table/table-head/table-head.component';
import { TableHeaderComponent } from '../../ui/table/table-header/table-header.component';
import { TableRowComponent } from '../../ui/table/table-row/table-row.component';
import { TableCellComponent } from '../../ui/table/table-cell/table-cell.component';
import { TeamNamePipe } from '../../pipes/team-name.pipe';
import { UserNamePipe } from '../../pipes/user-name.pipe';

@Component({
    selector: 'app-pending-requests',
    templateUrl: './pending-requests.component.html',
    imports: [
        RouterModule,
        TranslateModule,
        AsyncPipe,
        PageLayoutComponent,
        TableComponent,
        TableHeadComponent,
        TableHeaderComponent,
        TableRowComponent,
        TableCellComponent,
        TeamNamePipe,
        UserNamePipe
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PendingRequestsComponent implements OnInit {
    private readonly escalationService = inject(EscalationService);
    private readonly router = inject(Router);
    private readonly destroyRef = inject(DestroyRef);

    protected escalations = signal<EscalationView[]>([]);
    protected totalEscalations = signal(0);
    protected loading = signal(false);
    protected currentPage = signal(1);
    protected readonly pageSize = 10;
    protected readonly EscalationParentType = EscalationParentType;

    public ngOnInit(): void {
        this.loadEscalations(0);
    }

    protected onPageChange(page: number): void {
        this.currentPage.set(page);
        this.loadEscalations(page - 1);
    }

    protected openRequest(escalation: EscalationView): void {
        this.router.navigate([`/request/${escalation.resourceId}`]);
    }

    private loadEscalations(page: number): void {
        this.loading.set(true);
        this.escalationService
            .getEscalationViewsPaginated(page, this.pageSize)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                tap((response) => {
                    this.escalations.set(response.items);
                    this.totalEscalations.set(response.metadata.itemCount);
                    this.loading.set(false);
                })
            )
            .subscribe();
    }
}
